module.exports = {
  title: '营销消息',
  route: {
    path: '/content-manage',
    children: {
      path: 'market-sms-form',
    },
  },
};
